export default [
  'clickRequestDemoTooltip',
  'clickStartTrialTooltip'
]
